export class DataStreamUtils {
  static readonly MAX_ROWS_TO_DISPLAY = 250;

  static showExportFullDataset(totalRows?: number) {
    return totalRows ? totalRows > DataStreamUtils.MAX_ROWS_TO_DISPLAY : false;
  }
}
